import type { Toast, ToastVariant } from '@year13/kui/types/toast';

interface ShowToastOptions {
  variant: ToastVariant;
  message: string;
  title?: string;
  duration?: number;
}

const toasts = ref<Toast[]>([]);

const show = (options: ShowToastOptions) => {
  const toast: Toast = {
    id: crypto.randomUUID(),
    ...options,
  };
  toasts.value.push(toast);
};

const close = (id: string) => {
  toasts.value = toasts.value.filter(t => t.id !== id);
};

export const useToast = () => {
  return { toasts: readonly(toasts), show, close };
};
